import React, { useEffect } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { OfertasContext } from './context/ofertas-context';
import { Home } from './home';
import { Subpage } from './subpage';

export function App(): JSX.Element {
	const { logger, historyService, serviceConfigProvider, contentService } = React.useContext(OfertasContext);

	console.log('🚀 ~ App ~ logger', logger);
	console.log('🚀 ~ App ~ historyService', historyService);
	console.log('🚀 ~ App ~ serviceConfigProvider', serviceConfigProvider);
	console.log('🚀 ~ App ~ contentService.content', contentService?.content);

	useEffect(() => {
		const unregister = historyService.history.listen(() => {
			console.log('history changes', historyService.history.location.pathname);
		});
		return unregister;
	});

	return (
		<Router history={historyService.history}>
			<Switch>
				<Route exact path="/">
					<Home />
				</Route>
				<Route exact path="/subpage">
					<Subpage />
				</Route>
			</Switch>
		</Router>
	);
}
